(function () {
  'use strict';

  if (globalThis.__freeMaskInit) return;
  globalThis.__freeMaskInit = true;

  const SECTION_SELECTOR = '.free-mask-section-drawer';
  const BUTTON_SELECTOR = '[data-add-to-cart]';
  const SECTION_BUTTON_SELECTOR = SECTION_SELECTOR
    .split(',')
    .map(function (sel) { return sel.trim() + ' ' + BUTTON_SELECTOR; })
    .join(', ');

  try {
    // The freeMask flag is no longer read; delete any lingering value plus older keys.
    localStorage.removeItem('freeMask');
    localStorage.removeItem('sk-ii-free-sample-added');
    localStorage.removeItem('sk-ii-free-sample-variant-ids');
  } catch {
    // Legacy keys may not exist or storage may be unavailable; nothing to clean up.
  }

  function cartUrl(path) {
    const root = globalThis.Shopify?.routes?.root || '/';
    return (root + path).replace('//', '/');
  }

  let isAdding = false;
  let isRemoving = false;

  function toggleSections(hidden) {
    document.querySelectorAll(SECTION_SELECTOR).forEach(function (section) {
      section.style.display = hidden ? 'none' : '';
    });
  }

  let timerInterval = null;
  let timerRemaining = null;
  let timerExpired = false;

  function getConfiguredSeconds() {
    const el = document.querySelector('[data-js-timer-display]');
    if (!el) return 0;
    const parts = (el.textContent || '').trim().split(':');
    if (parts.length !== 2) return 0;
    const mins = Number.parseInt(parts[0], 10) || 0;
    const secs = Number.parseInt(parts[1], 10) || 0;
    return (mins * 60) + secs;
  }

  function renderTimer() {
    const mins = Math.floor(timerRemaining / 60);
    const secs = timerRemaining % 60;
    const text = mins + ':' + (secs < 10 ? '0' + secs : secs);
    document.querySelectorAll('[data-js-timer-display]').forEach(function (el) {
      el.textContent = text;
    });
  }

  function stopTimer() {
    if (timerInterval) {
      clearInterval(timerInterval);
      timerInterval = null;
    }
  }

  function startTimer() {
    if (timerInterval || timerExpired) return;
    if (timerRemaining === null) {
      timerRemaining = getConfiguredSeconds();
    }
    if (timerRemaining <= 0) return;
    renderTimer();
    timerInterval = setInterval(function () {
      timerRemaining -= 1;
      if (timerRemaining <= 0) {
        timerRemaining = 0;
        renderTimer();
        stopTimer();
        timerExpired = true;
        toggleSections(true);
        return;
      }
      renderTimer();
    }, 1000);
  }

  function resetTimer() {
    stopTimer();
    timerRemaining = null;
    timerExpired = false;
  }

  function resetButtons() {
    document.querySelectorAll(SECTION_BUTTON_SELECTOR).forEach(function (btn) {
      btn.disabled = false;
      btn.removeAttribute('disabled');
      btn.textContent = btn.dataset.label || 'ADD TO CART';
    });
  }

  function handleAdd(button) {
    const variantId = Number.parseInt(button.dataset.addToCart, 10);
    if (!variantId || button.disabled || isAdding) return;

    isAdding = true;
    const originalText = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding...';

    fetch(cartUrl('cart/add.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1, properties: { _free_mask: 'true' } }] })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Free Mask add-to-cart failed: HTTP ' + res.status);
        return res.json();
      })
      .then(function () {
        toggleSections(true);
        globalThis.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      })
      .catch(function () {
        button.disabled = false;
        button.textContent = originalText;
      })
      .then(function () {
        isAdding = false;
      });
  }

  // Only line items added via the free-mask button carry the _free_mask property,
  // so a paid instance of the same product — or the GWP gift (_gift_product) —
  // is never treated as the sample. Detection is property-only so the guard
  // works even when the timer section isn't rendered.
 function isFreeMaskItem(item) {
    return !!item?.properties?._free_mask;
  }

  function removeSampleItems(items) {
    const updates = {};
    items.forEach(function (item) {
      if (isFreeMaskItem(item)) updates[item.key] = 0;
    });
    if (Object.keys(updates).length === 0) return;

    isRemoving = true;
    fetch(cartUrl('cart/update.js'), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ updates: updates })
    })
      .then(function () {
        globalThis.dispatchEvent(new CustomEvent('theme:cart:refresh'));
      })
      .catch(function () {})
      .then(function () {
        isRemoving = false;
      });
  }

  function syncState() {
    fetch(cartUrl('cart.js'), { headers: { Accept: 'application/json' }, cache: 'no-store' })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        const items = cart.items || [];
        const hasSampleItems = items.some(isFreeMaskItem);
        const hasOtherItems = items.some(function (item) {
          return !isFreeMaskItem(item);
        });

        // Any non-sample line (paid product OR the GWP gift) is present → keep
        // the sample and show/hide the timer accordingly.
        if (hasOtherItems) {
          const keepHidden = hasSampleItems || timerExpired;
          toggleSections(keepHidden);
          if (keepHidden) {
            stopTimer();
          } else {
            startTimer();
          }
          if (!hasSampleItems) resetButtons();
          return;
        }

        // Only the sample remains → the cart is effectively empty, remove it.
        if (hasSampleItems) {
          if (!isRemoving) removeSampleItems(items);
          return;
        }

        // Truly empty cart: reset the timer for a fresh start. The sample is
        // never re-added here — only a manual button click adds it.
        resetTimer();
        toggleSections(true);
        resetButtons();
      })
      .catch(function () {});
  }

  document.addEventListener('click', function (e) {
    const button = e.target.closest(BUTTON_SELECTOR);
    if (!button?.closest(SECTION_SELECTOR)) return;
    e.preventDefault();
    handleAdd(button);
  });

  globalThis.addEventListener('theme:cart:updated', syncState);

  function init() {
    const section = document.querySelector(SECTION_SELECTOR);
    if (section && section.style.display !== 'none') {
      startTimer();
    }
    syncState();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
